import { Flex } from 'foundations-components/components/Flex';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { MerchCardShadowColumns } from './MerchCardSharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductTiles = ({
  columns,
  children
}) => {
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(MerchCardShadowColumns, {
        columns: columns,
        children: children
      })
    })
  });
};
export default ProductTiles;